export default __webpack_public_path__ + "assets/images/46a736e7193bac5698bd93cd00ab9943.png";